/**
 * Created by fworld on 2019/7/24.
 */
export default {
    grid: {
        left: '0',
        right: '0',
        top: '0',
        bottom: '3%',
        containLabel: true
    },

    // tooltip: {
    //     trigger: 'item',
    //     formatter: '{a} <br/>{b} : {c} ({d}%)'
    // },
    color: ['#5AD8A6', '#5B8FF9', '#F6BD16', '#E8684A'],
    legend: {
        type: 'scroll',
        orient: "vertical",
        x: "left",
        top: "center",
        left: "60%",
        bottom: "0%",
        data: [],
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 16,
        pageIconSize: 8,
        selected: {}
    },
    series: [
        {
            name: '设备制作杯数',
            type: 'pie',
            radius: ['55%', '80%'],
            avoidLabelOverlap: false,
            // label: {
            //     normal: {
            //         show: true,
            //         fontSize: '12'
            //     },
            //     emphasis: {
            //         show: true,
            //         fontSize: '12'
            //     }
            // },
            labelLine: {
                normal: {
                    show: true
                }
            },
            clockwise: false, //饼图的扇区是否是顺时针排布
            minAngle: 2, //最小的扇区角度（0 ~ 360）
            center: ["30%", "50%"],
            selectedMode: true,
            // itemStyle: { //图形样式
            //     normal: {
            //         borderColor: '#ffffff',
            //         borderWidth: 6,
            //     },
            // },
            label: {
                normal: {
                    show: false,
                    position: 'center',
                    formatter: '{text|{b}}\n{c} ({d}%)',
                    rich: {
                        text: {
                            color: "#40964b",
                            fontSize: 12,
                            align: 'center',
                            verticalAlign: 'middle',
                            padding: 8
                        },
                        value: {
                            color: "#8693F3",
                            fontSize: 12,
                            align: 'center',
                            verticalAlign: 'middle',
                        },
                    }
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: 16,
                    },
                    formatter: '{text|{b}}\n{c} ({d}%)',
                    rich: {
                        text: {
                            color: "#F2f2f2",
                            fontSize: 12,
                            align: 'center',
                            verticalAlign: 'middle',
                            padding: 8
                        },
                        value: {
                            color: "#8693F3",
                            fontSize: 12,
                            align: 'center',
                            verticalAlign: 'middle',
                        },
                    }
                }
            },
            data: [],

        }
    ]
}
